<template>
    <div >
		<van-list>
			<van-cell v-for="item in list" :key="item.personCode">
				<span @click="changePerson(item)">
					<span >{{item.personName}}</span>
					<span v-if="item.isDefault==1">(当前用户)</span>
				</span>
				<span style="float:right" v-if="item.isDefault!=1"><van-icon name="cross" size="20px" style="padding-top:5px;" @click="cancelUserBind(item)"/></span>
			</van-cell>
		</van-list>
		<div class="login-btn" style="padding-left:20px;padding-right:20px;padding-top:20px">
			<van-button block type="info" @click="addAccount"> 添 加 </van-button>
		</div>
    </div>
</template>

<script>
	import log from "utils/log"
	import apiLoginPage from "api/login-page"
	import apiUserPage from "api/user-page"
	import utils from '@/utils/util'
	import { saveToken,removeToken } from '@/utils/cache'
	import rsaKeyUtil from '@/utils/RsaKeyUtil'
	import {md5} from '@/utils/md5'
	import store from '@/store'
    export default {
		name:'Login',
        data() {
            return {
				showPicker:false,
				list:[],
				isWx: utils.isWeChatBrowser()
            }
		},
		created() {
			this.listPerson();
		},
        methods: {
			listPerson(){
				let openId = this.$store.getters.openId
				apiUserPage.listPerson({"openId": openId}).then(res => {
					this.list = res.data;
					this.list[0].isDefault = 1;
				})
			},
			changePerson(item){
				if(item.isDefault==1){
					return;
				}
				let openId = this.$store.getters.openId
				apiUserPage.changePerson({"openId": openId, "userCode": item.personCode}).then(res => {
					saveToken(res.data.token)
					this.$store.dispatch('mars/user/getUserInfo')
					this.$notify({
						message: "切换账户成功。",
						type: "success",
						});
					this.listPerson();
				})
			},
			addAccount(){
				this.$router.push({ path:'/add-account' })
			},
			cancelUserBind(item){
				if(item.isDefault==1){
					return;
				}
				this.$dialog.confirm({
                    title: '提示',
                    message: '是否解除账户绑定？',
                })
                .then(() => {
                    let openId = this.$store.getters.openId
					apiUserPage.deletePerson({"openId": openId, "userCode": item.personCode}).then(res => {
						removeToken();
						this.$notify({
							message: "解除账户绑定成功。",
							type: "success",
							});
						this.listPerson();
					})
                })
                .catch(() => {
                    // on cancel
                     console.log("logout cancel")
                });
			},
        },
    }
</script>

<style lang='scss'>
	.nobd.van-field {
		padding-left: 0;
		&::after {
			border: none;
		}
	}
	
</style>
